import Config from "../config/Config";

const initialState = {
    styles: {
        isMobile: window.matchMedia(`(max-width: ${Config.styles.MEDIA_QUERY_MOBILE}px)`).matches
    }
};

export default initialState;
